// Imports
import ___CSS_LOADER_API_SOURCEMAP_IMPORT___ from "../../../../node_modules/css-loader/dist/runtime/sourceMaps.js";
import ___CSS_LOADER_API_IMPORT___ from "../../../../node_modules/css-loader/dist/runtime/api.js";
var ___CSS_LOADER_EXPORT___ = ___CSS_LOADER_API_IMPORT___(___CSS_LOADER_API_SOURCEMAP_IMPORT___);
// Module
___CSS_LOADER_EXPORT___.push([module.id, `.ComponentsError_container__TAad3 {
  width: 100%;
  height: 86vh;
  display: flex;
  align-items: center;
  flex-direction: column;
  gap: 40px;
}

.ComponentsError_title__PC9aU {
  font-family: sans-serif;
  font-weight: 500;
  font-size: 3em;
}

.ComponentsError_title500__rQDnP {
  font-family: sans-serif;
  font-weight: 500;
  text-align: center;
  font-size: 3em;
  margin-left: 30px;
  margin-right: 30px;
}

.ComponentsError_container_error__Ags4Q {
  display: flex;
  flex-direction: column;
  height: 100%;
}

.ComponentsError_errorImage__QlLmx {
  width: 20vw;
  margin-top: 10vw;
}

.ComponentsError_errorCode__7jpl1 {
  font-size: 1em;
}
`, "",{"version":3,"sources":["webpack://./src/components/ErrorPages/ComponentsError/index.module.css"],"names":[],"mappings":"AAAA;EACE,WAAW;EACX,YAAY;EACZ,aAAa;EACb,mBAAmB;EACnB,sBAAsB;EACtB,SAAS;AACX;;AAEA;EACE,uBAAuB;EACvB,gBAAgB;EAChB,cAAc;AAChB;;AAEA;EACE,uBAAuB;EACvB,gBAAgB;EAChB,kBAAkB;EAClB,cAAc;EACd,iBAAiB;EACjB,kBAAkB;AACpB;;AAEA;EACE,aAAa;EACb,sBAAsB;EACtB,YAAY;AACd;;AAEA;EACE,WAAW;EACX,gBAAgB;AAClB;;AAEA;EACE,cAAc;AAChB","sourcesContent":[".container {\n  width: 100%;\n  height: 86vh;\n  display: flex;\n  align-items: center;\n  flex-direction: column;\n  gap: 40px;\n}\n\n.title {\n  font-family: sans-serif;\n  font-weight: 500;\n  font-size: 3em;\n}\n\n.title500 {\n  font-family: sans-serif;\n  font-weight: 500;\n  text-align: center;\n  font-size: 3em;\n  margin-left: 30px;\n  margin-right: 30px;\n}\n\n.container_error {\n  display: flex;\n  flex-direction: column;\n  height: 100%;\n}\n\n.errorImage {\n  width: 20vw;\n  margin-top: 10vw;\n}\n\n.errorCode {\n  font-size: 1em;\n}\n"],"sourceRoot":""}]);
// Exports
___CSS_LOADER_EXPORT___.locals = {
	"container": `ComponentsError_container__TAad3`,
	"title": `ComponentsError_title__PC9aU`,
	"title500": `ComponentsError_title500__rQDnP`,
	"container_error": `ComponentsError_container_error__Ags4Q`,
	"errorImage": `ComponentsError_errorImage__QlLmx`,
	"errorCode": `ComponentsError_errorCode__7jpl1`
};
export default ___CSS_LOADER_EXPORT___;
